import { AsphaltLotId } from '../filenameTemplateItems/instances/asphalt'
import { ConcreteTestSetId } from '../filenameTemplateItems/instances/concrete'
import {
  DailyControlPointId,
  DailyInspectionId,
  DailyPunchListId,
} from '../filenameTemplateItems/instances/dailyInspection'
import { DensityLotId } from '../filenameTemplateItems/instances/density'
import {
  asphalts,
  concretes,
  controlPoints,
  densities,
  inspections,
  projects,
  punchLists,
  workTypes,
} from '../filenameTemplateItems/instances/groups'
import { PhotoExportClassTypeItem } from './PhotoExportClassTypeItem'

export const AsphaltLot = new PhotoExportClassTypeItem({
  id: '647D47F9-BB57-4268-8E75-FBDEEB314581',
  classType: 'AsphaltLot',
  classTypeName: 'Asphalt Lot',
  compatibleTemplateItems: [...projects, ...asphalts],
  identifier: AsphaltLotId,
})

export const ConcreteTestSet = new PhotoExportClassTypeItem({
  id: '4BCE71AA-8448-4635-8A06-5C9E71766CDA',
  classType: 'ConcreteTestSet',
  classTypeName: 'Concrete Test Set',
  compatibleTemplateItems: [...projects, ...concretes, ConcreteTestSetId],
  identifier: ConcreteTestSetId,
})

export const ControlPoint = new PhotoExportClassTypeItem({
  id: 'C74F58F7-D347-4B7B-8B47-1D64CBC46DF1',
  classType: 'DailyInspectionControlPoint',
  classTypeName: 'Control Point',
  compatibleTemplateItems: [...projects, ...workTypes, ...controlPoints],
  identifier: DailyControlPointId,
})

export const Inspection = new PhotoExportClassTypeItem({
  id: '83BB008B-5249-4B28-9399-0E7FF7B3A405',
  classType: 'DailyInspectionInspection',
  classTypeName: 'Inspection',
  compatibleTemplateItems: [...projects, ...workTypes, ...inspections],
  identifier: DailyInspectionId,
})

export const PunchList = new PhotoExportClassTypeItem({
  id: 'F4DB0CE2-9AD3-4926-8014-4E59110C002E',
  classType: 'DailyInspectionPunchList',
  classTypeName: 'Punch List',
  compatibleTemplateItems: [...projects, ...workTypes, ...punchLists],
  identifier: DailyPunchListId,
})

export const DensityLot = new PhotoExportClassTypeItem({
  id: 'AAA44A4F-9B7F-4193-A8AE-7CF6F9CAF2F0',
  classType: 'Lot',
  classTypeName: 'Density Lot',
  compatibleTemplateItems: [...projects, ...densities],
  identifier: DensityLotId,
})
